<template>
  <v-container class="copyright pa-0 text-center text-sm-left" style="color: #a8a8a8;">
    <v-row
      class="align-center"
      :class="{ 'flex-column': $vuetify.breakpoint.xsOnly }"
    >
    <v-col>
      © Copyright Národní knihovna ČR. All rights reserved.
    </v-col>
      <v-col class="text-center text-sm-right">
        <a
          style="color: #a8a8a8;"
          target="_blank"
          class="text-uppercase text-decoration-none hover-underline mr-2"
          :href="$t('footer.link')"
          >{{ $t("footer.title") }}</a
        >
        <a
          style="color: #a8a8a8;"
          target="_blank"
          class="text-uppercase text-decoration-none hover-underline"
          :href="$t('footer.privacyPolicyPdf')"
          >{{ $t("footer.privacyPolicy") }}</a
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Copyright",
};
</script>

<style lang="scss">
.copyright {
  font-size: 14px;
}
.no-decoration {
  text-decoration: none;
}
.hover-underline:hover {
  text-decoration: underline !important;
}
</style>